import { render, staticRenderFns } from "./FbRubric.vue?vue&type=template&id=6b9b9b1a"
import script from "./FbRubric.vue?vue&type=script&lang=js"
export * from "./FbRubric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports